import { Sparkles } from "lucide-react";

const ITEMS = [
  "Manicura Rusa",
  "Soft Gel",
  "Acrílico Esculpido",
  "Nail Art de Autor",
  "Rubber Base",
  "Pedicura Spa",
  "Hecho con cariño venezolano",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      aria-hidden="true"
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-sand bg-creamcard py-5 select-none"
    >
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((t, i) => (
          <span
            key={i}
            className="flex items-center gap-10 font-display text-xl sm:text-2xl italic text-gold/70"
          >
            {t}
            <Sparkles className="w-4 h-4 text-rosegold" />
          </span>
        ))}
      </div>
    </section>
  );
}
